var map = {
	"./articles/png/bear1.png": "5f0f",
	"./articles/png/bear2.png": "8d6a",
	"./articles/png/bear3.png": "3582",
	"./articles/png/bear4.png": "5c61",
	"./articles/png/bear5.png": "edb5",
	"./articles/png/bear6.png": "c012",
	"./articles/png/bear7.png": "89ae",
	"./articles/png/bear8.png": "82ec",
	"./articles/png/bear9.png": "5285",
	"./frame_2.png": "65fc",
	"./frame_3.png": "a769",
	"./frame_logo_emporio_armani.png": "493b",
	"./textures/chalk_1.png": "53ec",
	"./textures/chalk_10.png": "247f",
	"./textures/chalk_11.png": "63e3",
	"./textures/chalk_12.png": "0ec1",
	"./textures/chalk_13.png": "9a87",
	"./textures/chalk_14.png": "4570",
	"./textures/chalk_15.png": "1506",
	"./textures/chalk_2.png": "253d",
	"./textures/chalk_3.png": "a6f1",
	"./textures/chalk_4.png": "46be",
	"./textures/chalk_5.png": "e9fa",
	"./textures/chalk_6.png": "8767",
	"./textures/chalk_7.png": "3d0a",
	"./textures/chalk_8.png": "8b27",
	"./textures/chalk_9.png": "e205",
	"./ui/tools/eraser.png": "0d79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";